var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirportBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 75.000000 75.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,75.000000) scale(0.100000,-0.100000)",
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337 662 c-13 -14 -17 -39 -17 -104 0 -75 -2 -87 -23 -106 -13 -12 -29 -22 -35 -22 -7 0 -12 -4 -12 -9 0 -5 -10 -13 -22 -18 -13 -4 -53 -28 -90 -53 -52 -34 -68 -50 -68 -68 0 -19 4 -23 17 -17 18 7 75 25 163 50 62 18 70 9 70 -82 0 -70 -2 -77 -30 -103 -34 -31 -42 -67 -12 -55 67 29 126 29 195 0 29 -12 21 24 -13 55 -28 26 -30 33 -30 103 0 50 4 78 12 84 17 10 66 4 103 -12 17 -8 46 -18 65 -23 19 -6 43 -13 53 -17 13 -6 17 -2 17 17 0 18 -15 34 -67 68 -37 25 -74 48 -83 52 -8 4 -33 20 -55 36 l-40 28 -3 89 c-2 65 -7 94 -19 107 -21 23 -55 23 -76 0z",
    fill: "#0F3ECA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportBlue);
export default __webpack_public_path__ + "static/media/airport_blue.cf766cfa08d4c061c8ba6cca27a4161d.svg";
export { ForwardRef as ReactComponent };